<template>
    <g :class="'flow-graph '+'weight-'+weight ">
        <path
            stroke-width="3"
            :d="path"
            fill="none"
        />
    </g>
</template>

<script>
export default {
    props: {
        path: {
            type: String,
        },
        weight: {
            type: String,
            default: 'pending',
        },
    },
    data() {
        return {
            ystep: this.y1 + 30,
        };
    },
    computed: {},
    methods: {
        // eslint-disable-next-line consistent-return
        color() {
            switch (this.weight) {
                case 'pending':
                    return '#949393';
                case 'failure':
                case 'error':
                    return '#eb2f3c';
                case 'success':
                case 'current':
                    return '#8cc04f';
                default:
                    break;
            }
        },
    },
};
</script>
<style lang="css">
.flow-graph-connector {
  stroke: #949393;
}
</style>
